/* global Localize */
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
    Button,
    Checkbox,
    Container,
    Dropdown,
    Form,
    Header,
    Icon,
    Segment,
} from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

const PassordInputWithCapsLockIndicator = (props) => {
    const { t } = useTranslation()
    const [capsLockActivated, setCapsLockActivated] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    useEffect(() => {
        const handleKeyDown = (event) => {
            setCapsLockActivated(
                event.getModifierState
                && event.getModifierState("CapsLock")
            )
        }
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [])

    return (
        <>
            {props.hideField ? (
                <></>
            ) : (
                <Form.Field style={{ marginBottom: capsLockActivated ? 0 : 16, position: 'relative' }}>
                    <Form.Input
                        className="LoginPasswordInput"
                        fluid
                        type={showPassword ? "text" : "password"}
                        value={props.password}
                        icon={<Icon name='lock' style={{ color: capsLockActivated ? 'red' : (props.iconColor || 'gray') }} />}
                        iconPosition='left'
                        onChange={(e) => props.onChange(e.target.value)}
                        placeholder={t('Contraseña')}
                    />
                    <Icon
                        name={showPassword ? 'eye' : 'eye slash'}
                        style={{
                            position: 'absolute',
                            right: 12,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            color: props.iconColor || 'gray',
                            zIndex: 10
                        }}
                        onClick={() => setShowPassword(!showPassword)}
                    />
                </Form.Field>
            )}

            {capsLockActivated && (
                <Container textAlign="center" style={{ marginBottom: 16 }}>
                    <label
                        style={{ color: 'white', textDecoration: 'none', fontSize: '1rem', ...props.labelStyle }}
                    >
                        {t('La tecla Bloq Mayús está activa')}
                    </label>
                </Container>
            )}
        </>
    )
}

const mapStateToProps = (state) => ({
    lang: state.app?.lang ?? 'es'
})

const mapDispatchToProps = (dispatch) => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(PassordInputWithCapsLockIndicator)
